import PageBreadcrumb, {
  PageBreadcrumbItem,
} from "components/common/PageBreadcrumb";
import { Col, Row, Spinner } from "react-bootstrap";
import img from "assets/img/spot-illustrations/timeline.png";
import imgDark from "assets/img/spot-illustrations/timeline-dark.png";
import BasicTimeline from "components/timelines/BasicTimeline";
import axios from "axios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { convertVersoesToTimelineData } from "helpers/timelineAdapter";

export const timelineBreadcrumb: PageBreadcrumbItem[] = [
  {
    label: "Revenda",
    url: "#!",
  },
  {
    label: "Versões",
    active: true,
  },
];

const VersaoTimeline = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["versoes"],
    queryFn: async () => {
      const response = await axios.get("/api/admin/versao", {
        params: {
          pageSize: 100, // Valor alto para obter todas as versões
          pageIndex: 0,
          sort: "createdAt,desc", // Ordenar por data de criação (mais recente primeiro)
        },
      });
      return response.data;
    },
    placeholderData: keepPreviousData,
  });

  if (isLoading) {
    return (
      <div className="text-center">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center">
        <h4>Erro ao carregar os dados</h4>
      </div>
    );
  }

  // Converter os dados para o formato da timeline
  const timelineData = convertVersoesToTimelineData(data?.data);

  return (
    <>
      <PageBreadcrumb
        items={timelineBreadcrumb}
        className="breadcrumb-sticky-top"
      />
      <h2 className="text-bold mb-5 page-title-sticky-top">Versões lançadas</h2>

      {!timelineData || timelineData.length === 0 ? (
        <div className="alert alert-subtle-primary" role="alert">
          Nenhuma versão encontrada. As versões cadastradas serão exibidas aqui.
        </div>
      ) : (
        <Row className="gx-xl-8 gx-xxl-11">
          <Col xl={5} className="p-xxl-7">
            <div
              className="ms-xxl-3 d-none d-xl-block position-sticky"
              style={{ top: "30%" }}
            >
              <img src={img} alt="" className="d-dark-none img-fluid" />
              <img src={imgDark} alt="" className="d-light-none img-fluid" />
            </div>
          </Col>
          <Col xl={7} className="scrollbar">
            {timelineData.map((timeline: any) => (
              <div key={timeline.id}>
                <h4 className="py-3 border-y mb-5 ms-8">{timeline.date}</h4>
                <BasicTimeline data={timeline.items} />
              </div>
            ))}
          </Col>
        </Row>
      )}
    </>
  );
};

export default VersaoTimeline;
